<template>
    <el-dialog
    title="รายชื่อแก้ไข"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    :visible.sync="dialogShowEditOrderMobile.isShow"
    width="30%"
    custom-class="dialogShowEditOrderMobile"
    center>
    <el-row>
        <el-col :span="24" class="text-md-center">
            <el-date-picker
                v-model="datePick"
                type="date"
                @change="fetch"
                :picker-options="datePickerOptions"
                format="yyyy-MM-dd"
                value-format="yyyy-MM-dd"
                placeholder="เลือกวันที่"/>
        </el-col>
        <el-col :span="24">
             <el-table
                :data="tableData"
                stripe
                style="width: 100%">
                <el-table-column
                prop="editor"
                label="email">
                </el-table-column>
                <el-table-column
                prop="orderQuantity"
                label="orderQuantity"
                width="180">
                </el-table-column>
            </el-table>
        </el-col>
    </el-row>
    <span slot="footer" class="dialog-footer">
        <el-button @click="dialogShowEditOrderMobile.isShow = false">ปิด</el-button>
    </span>
    </el-dialog>
</template>
<script>
import fgApi from '@/services/fillgoods'
export default {
    name: 'MobileOrderDialogEditOrder',
    props: {
        dialogShowEditOrderMobile: {
            type: Object
        }
    },
    data () {
        return {
            datePick: this.$dayjs().format('YYYY-MM-DD'),
            tableData: [],
            datePickerOptions: {
                disabledDate: (date) => {
                    return date < new Date('2019-12-11')
                }
            }
        }
    },
    watch: {
        'dialogShowEditOrderMobile.isShow' (val) {
            if (val) {
                this.tableData = []
                this.datePick = this.$dayjs().format('YYYY-MM-DD')
                this.fetch()
            }
        }
    },
    methods: {
        async fetch () {
            let loading = this.$loading({
                target: '.dialogShowEditOrderMobile'
            })

            try {
                let param = {
                    date: String(this.datePick)
                }
                let res = await fgApi.log.getEditorMobileLog(param)
                // console.log(res)
                if (res.success) {
                    this.tableData = res.data.filter(item => item.editor !== 'Auto save system')
                } else {
                    this.$notify.error({
                        title: 'Error',
                        message: res.message
                    })
                }
            } catch (error) {
                this.$notify.error({
                    title: 'Error',
                    message: error
                })
            }
            loading.close()
        }
    }
}
</script>
